import { render, staticRenderFns } from "./OrderSingleShipmentCarrierDetails.vue?vue&type=template&id=381bd85b&"
import script from "./OrderSingleShipmentCarrierDetails.vue?vue&type=script&lang=js&"
export * from "./OrderSingleShipmentCarrierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports